<template>
  <div>
    <calculator-interface
      :current-value="currentValue"
      @button-click="handleClick"
    ></calculator-interface>
  </div>
</template>

<script>
import CalculatorInterface from './CalculatorInterface.vue';
import evaluate from './evaluate';

export default {
  components: {
    CalculatorInterface,
  },

  data() {
    return {
      currentInput: '',
      inputTokens: [],
      errorMessage: '',
    };
  },

  computed: {
    currentValue() {
      if (this.errorMessage) return this.errorMessage;
      if (this.currentInput) return this.currentInput;
      return String(evaluate(this.inputTokens));
    },
  },

  methods: {
    /**
     * If there is no new input and there are at least 3 tokens,
     * do the last calculation again by concatenating a copy of the last 2 tokens
     */
    addTokensRecalculation() {
      if (this.inputTokens.length > 2 && this.currentInput === '' && this.inputTokens.length % 2 === 1) {
        this.inputTokens = [...this.inputTokens, ...this.inputTokens.slice(-2)];
      }
    },
    /**
     * If the token array has grown to 5 or more, we can calculate a partial result
     * and replace all but the last 2 tokens with the result
     */
    replaceTokensWithPartialResult() {
      if (this.inputTokens.length < 5  || this.inputTokens.length % 2 === 0) return;
      const partialResult = evaluate(this.inputTokens.slice(0, -2));
      this.inputTokens = [
        String(partialResult),
        ...this.inputTokens.slice(-2),
      ];
    },
    handleErrorMessage() {
      if (this.isErrorMessage(evaluate(this.inputTokens))) {
        this.errorMessage = String(evaluate(this.inputTokens));
        this.inputTokens = [];
      }
    },
    insertNewInput() {
      if (this.currentInput === '') return;

      const lastToken = this.inputTokens[this.inputTokens.length - 1];
      if (lastToken === '+' || lastToken === '-' || lastToken === '*' || lastToken === '/') {
        this.inputTokens.push(this.currentInput);
        this.currentInput = '';
      }
    },
    handleClick(button) {
      const parsed = parseFloat(button);

      if (!Number.isNaN(parsed)) {
        if (this.currentInput === '0') {
          this.currentInput = String(parsed);
        } else {
          this.currentInput += String(parsed);
        }
        if (this.errorMessage) this.errorMessage = '';
      }

      if (button === '.') {
        if (this.currentInput === '') {
          this.currentInput = '0.';
        }

        if (!this.currentInput.includes('.')) {
          this.currentInput += '.';
        }
        if (this.errorMessage) this.errorMessage = '';
      }

      const operators = ['+', '-', '*', '/'];

      if (operators.includes(button)) {
        if (this.currentInput !== '') {
          this.inputTokens.push(this.currentInput);
          this.currentInput = '';
        }

        const mostRecentToken = this.inputTokens[this.inputTokens.length - 1];
        if (operators.includes(mostRecentToken)) {
          this.inputTokens.pop();
        }

        this.inputTokens.push(button);
      }

      if (button === '=') {
        this.addTokensRecalculation();
        this.insertNewInput();
        this.replaceTokensWithPartialResult();
        this.handleErrorMessage();
      }

      if (button === 'AC') {
        this.currentInput = '';
        this.inputTokens = [];
      }

      if (button === '+/-') {
        if (this.currentInput !== '') {
          this.currentInput = String(-parseFloat(this.currentInput));
        } else {
          const value = evaluate(this.inputTokens);
          this.currentInput = String(-value);
          this.inputTokens = [];
        }
      }

      if (button === '%') {
        if (this.currentInput !== '') {
          this.currentInput = String(parseFloat(this.currentInput) / 100);
        } else {
          const value = evaluate(this.inputTokens);
          this.currentInput = String(value / 100);
          this.inputTokens = [];
        }
      }

      if (button === '√') {
        if (this.currentInput !== '') {
          this.currentInput = String(Math.sqrt(parseFloat(this.currentInput)));
        } else {
          const value = evaluate(this.inputTokens);
          this.currentInput = String(Math.sqrt(value));
          this.inputTokens = [];
        }
      }
    },

    isErrorMessage(result) {
      if (result === Infinity) return true;
      if (result === -Infinity) return true;
      if (result === NaN) return true;
      return false;
    },
  },
};
</script>

<style>

</style>
